<template>
	<PageContainer size="s">
		<AmeliproCard
			card-title="Modification du mot de passe"
			class="pa-6"
		>
			<VForm ref="form">
				<AmeliproTextField
					id="currentPasswordUser"
					v-model="currentPasswordUser"
					required
					aria-required
					class="text-no-wrap"
					label="Mot de passe actuel"
					placeholder="Mot de passe"
					:type="typeChamp"
					validate-on-blur
					@keyup.enter="submitUpdatePassword"
				>
					<template #append>
						<AmeliproIconBtn
							id="displayPassword"
							btn-label="displayPassword"
							icon-bg-color="ap-white"
							icon-color="ap-blue darken-1"
							icon-hover-bg-color="ap-blue darken-2"
							icon-hover-color="ap-white"
							icon="oeil"
							large
							@click="togglePasswordVisibility"
						/>
					</template>
				</AmeliproTextField>

				<AmeliproTextField
					id="passwordUser"
					v-model="passwordUser"
					:rules="passwordRules"
					required
					aria-required
					class="text-no-wrap"
					label="Nouveau mot de passe"
					placeholder="Mot de passe"
					:type="typeChamp"
					validate-on-blur
					@keyup.enter="submitUpdatePassword"
				>
					<template #append>
						<AmeliproIconBtn
							id="displayPassword"
							btn-label="displayPassword"
							icon-bg-color="ap-white"
							icon-color="ap-blue darken-1"
							icon-hover-bg-color="ap-blue darken-2"
							icon-hover-color="ap-white"
							icon="oeil"
							large
							@click="togglePasswordVisibility"
						/>
					</template>
				</AmeliproTextField>

				<AmeliproTextField
					id="passworduserDeux"
					v-model="passworduserDeux"
					:rules="passwordRulesFull"
					required
					aria-required
					label="Confirmation du nouveau mot de passe"
					placeholder="mot de passe"
					:type="typeChamp"
					validate-on-blur
					class="text-no-wrap"
					@keyup.enter="submitUpdatePassword"
				>
					<template #append>
						<AmeliproIconBtn
							id="displayPassword"
							btn-label="displayPassword"
							icon-bg-color="ap-white"
							icon-color="ap-blue darken-1"
							icon-hover-bg-color="ap-blue darken-2"
							icon-hover-color="ap-white"
							icon="oeil"
							large
							@click="togglePasswordVisibility"
						/>
					</template>
				</AmeliproTextField>

				<div class="d-flex flex-column flex-sm-row justify-sm-space-between">
					<div class="ml-auto">
						<AmeliproBtn @click="submitUpdatePassword">
							Valider
						</AmeliproBtn>
					</div>
				</div>
			</VForm>
		</AmeliproCard>
	</PageContainer>
</template>

<script lang="ts">
	import Component, { mixins } from 'vue-class-component';

	import { required } from '@cnamts/vue-dot/src/rules/required';
	import { Refs, VForm } from '@cnamts/vue-dot/src/types';
	import { updateUtilisateurApi } from '@/services/api/api';
	import { store } from '@/store';
	import UserMixin from '@/mixins/userMixin';
	import { Meta, MetaInfo } from '@/decorators';
	const MixinsDeclaration = mixins(UserMixin);

	@Component<ResetPassword>({
		mounted() {
			// Accédez au paramètre de l'URL
			this.token = this.$route.params.token;
		}
	})
	export default class ResetPassword extends MixinsDeclaration {
		@Meta
		metaInfo(): MetaInfo {
			return {
				title: 'PEGASE - Modification du mot de passe' as string
			};
		}
		$refs!: Refs<{
			form: VForm;
		}>;

		token = '';
		currentPasswordUser = '';
		passwordUser = '';
		passworduserDeux = '';
		passworError = '';

		passwordRules = [required, this.validatePassword];
		passwordRulesFull = [required, this.validatePassword, this.passwordMatch];

		typeChamp = 'password';
		showPassword = false;

		//@input="clearError"
		togglePasswordVisibility(): void {
			this.showPassword = !this.showPassword;
			this.typeChamp = this.showPassword ? 'text' : 'password';
		}

		passwordMatch(): boolean | string {
			return this.stringMatch(
				this.passwordUser,
				this.passworduserDeux,
				'Les mots de passe ne correspondent pas'
			);
		}

		async submitUpdatePassword(): Promise<void> {
			await this.$nextTick(); // attend la mise à jour du cycle de vie (dom)
			if (this.$refs.form.validate()) {
				try {
					const response = await updateUtilisateurApi({
						currentPassword: this.currentPasswordUser,
						newPassword: this.passwordUser
					});
					if (response && 'data' in response) {
						this.$router.push('/');
						store.dispatch('notification/add', {
							type: 'success',
							message: 'Le mot de passe a été mis à jour'
						});
					}
				} catch (error: any) {
					let errorMessage =
						'Une erreur est survenue lors de la mise à jour du mot de passe.';
					if (
						error.response &&
						error.response.data &&
						error.response.data.error
					) {
						errorMessage += ` Message : ${error.response.data.error}`;
					} else {
						errorMessage += ` Erreur : ${error.message}`;
					}
					store.dispatch('notification/add', {
						type: 'error',
						message: errorMessage
					});
				}
			}
		}

		// new
	}
</script>
